import React from "react";
import Icon, {IconProps} from "./Icon";

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    iconClassName?: string;
}

export default function IconButton(props: IconButtonProps & IconProps) {
    const { iconClassName, ...rest } = props;
    return (
        <button type={props.type || "button"} className={props.className || "unstyled-button"} onClick={props.onClick}>
            <Icon {...rest} className={iconClassName}/>
        </button>
    )
}
